import { Link } from "react-router-dom"
import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  showText?: boolean
  size?: "sm" | "md" | "lg"
}

export function Logo({ className, showText: _showText = true, size = "md" }: LogoProps) {
  const sizes = {
    sm: "h-6",
    md: "h-8",
    lg: "h-12",
    xl: "h-16",
  }

  return (
    <Link to="/" className={cn("flex items-center gap-2", className)}>
      <img
        src="/logo-transparent.png"
        alt="Woezor"
        className={cn(sizes[size], "w-auto")}
      />
    </Link>
  )
}

// Brand colors extracted from the logo
export const brandColors = {
  primary: {
    light: "#3DD6D0",    // Light teal
    DEFAULT: "#14B8A6",  // Teal
    dark: "#0891B2",     // Deep teal/cyan
  },
  gradient: {
    from: "#3DD6D0",     // Light teal
    to: "#0891B2",       // Deep teal/cyan
  }
}
